import './modifyLimitStep3.scss';

import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { i18n } from 'core/i18n';
import * as cardModifyNewLimitActions from 'actions/cardModifyNewLimit/cardModifyNewLimit';
import * as cardChangePaymentMethodActions from 'actions/cardChangePaymentMethod';
import CardModifyLimitInformativeSection from 'components/cards/cardModifyLimit/cardModifyLimitInformativeSection/cardModifyLimitInformativeSection';
import { HireNewCreditCardPdf } from 'components/hire/newCreditCard/hireNewCreditCardPdf/hireNewCreditCardPdf';
import { OKConsents } from 'gdpr-consents/components/OKConsents/OKConsents.js';
import { GDPRSignaturePattern } from 'components/gdprSignaturePattern/gdprSignaturePattern';
import { isPrintOfficeMode } from 'utilities/contactCenter/printerHelper';
import ContactCenterRender from 'components/conditionalRender/contactCenterRender';
import { nonNumericFilter } from 'utilities/stringHelper';
import { CARD_MODIFY_LIMIT_DECREASE, EURO_TEXT, SECOND_STEP } from 'constants/index';
import { CARD_DECREASE_LIMIT_ID, CARD_INCREASE_LIMIT_ID } from 'constants/operationTypes';
import ContactCenterNewValidationCards from 'components/hire/contactCenterValidationCards/contactCenterNewValidationCards';
import BlockInfo from 'components/contactCenter/blockInfo/blockInfo';
import PersonalDataHelper from 'utilities/personalDataHelper';
import { recordLinkV2 } from 'utilities/tagging';

const ModifyNewLimitStep3 = (props) => {
    const {
        immCard,
        immCardModifyLimit,
        immHireCreditLimit,
        placementIdCard,
        immHireCardNameSelector,
        immHirePaymentMethod,
        immShippingAddressList,
        immCardChangePaymentMethod,
        handleAgreementCheckboxChange,
        processEmail,
        onHandleChangeCheckBoxCC,
        immProfile,
        pageName = '',
        getCustomTags
    } = props
    const { FormattedText, formatText } = i18n;

    const [printOffice, setPrintOffice] = useState(false)
    const creditLimit = immHireCreditLimit.get('creditLimit');
    const amount = immCard.getIn(['limit', 'amount'])
    const name = PersonalDataHelper.getFullName(immProfile, false);
    const keyName = `<b>${name}</b>`;
    const documentPolicy = immCardChangePaymentMethod.get('documentPolicy');
    const mailSent = immCardModifyLimit.get('mailSent')
    const operativeName = immCardModifyLimit.get('operationType') === CARD_MODIFY_LIMIT_DECREASE ?
        formatText('operatives-decreaseCardLimit')
        :
        formatText('operatives-increaseCardLimit');
    const newLimit = {
        amount: creditLimit,
        currency: EURO_TEXT
    };
    const onHandleChangeCheckBox = (evt) => {
        return handleAgreementCheckboxChange(evt, FOURTH_STEP)
    }

    const handleSMSClick = () => {
        if (getCustomTags) {
            const tag = getCustomTags({ pageName }).onSMSClick;
            recordLinkV2(tag);
        }
    };

    const buildSignatureSection = () => {
        const params = {};
        let operationType;
        const operationProcessId = immCardModifyLimit.get('operationProcessIdInitPolicy')
        const showsignaturepattern = __CONTACT_CENTER__ && isPrintOfficeMode() ? printOffice && operationProcessId : operationProcessId

        if (amount > creditLimit) {
            params.ammount = creditLimit;
            params.currency = EURO_TEXT;
            params.pan = nonNumericFilter(immCard.get('number'));
            operationType = CARD_DECREASE_LIMIT_ID;

        } else {
            params.pan = nonNumericFilter(immCard.get('number'));
            operationType = CARD_INCREASE_LIMIT_ID;
            params.operationProcessId = operationProcessId
            params.evidenceType = "SIGN_DOCUMENT"

        }
        return (
            showsignaturepattern &&
            <section className="modify-limit-step-two__content">
                {__CONTACT_CENTER__ && !isPrintOfficeMode() &&
                    <FormattedText value={'cardModifyLimitInformativeSection-blockInfo3Step3'} injectedStrings={[keyName]} />
                }
                <GDPRSignaturePattern
                    operationType={operationType}
                    operationParams={params}
                    newOperationProcessId={operationProcessId}
                    sendOnlyOperationProcessid={true}
                    isEasyLoanTypeAB={true}
                    handleSMSClick={handleSMSClick}
                    isOverDraft={!isPrintOfficeMode() && true}

                />
            </section>
        )
    }
    const buildLegalConfirmationSection = (amount) => {
        const productType = immHireCreditLimit.get('productType');
        const productSubType = immHireCreditLimit.get('productSubType');
        const standard = immHireCreditLimit.get('referenceStandard');
        const precontractualMailProductInfo = {
            productName: 'Vanity Fair Card',
            producto: productType,
            standard: standard,
            subproducto: productSubType,
        }

        const immStep = immCardModifyLimit.getIn(['steps', SECOND_STEP]);
        const agreementLabel = <FormattedText value={'hireCardNeruda-hireCardNeruda_step4NewCheckboxText'} />;
        const agreementErrorMsg = formatText('hireCardNeruda-hireCardNeruda_step4CheckboxErrorMsg');
        const documentINE = immCardModifyLimit.get('documentINE')
        const documentPolicy = immCardModifyLimit.get('documentPolicy')
        const newIntLoading = documentINE
        const sendMailParams = {
            type: productType,
            subType: productSubType,
            standar: standard,
        };
        return (
            <ContactCenterNewValidationCards
                amount={amount}
                agreementErrorMsg={agreementErrorMsg}
                agreementLabel={agreementLabel}
                contractName="visa-open"
                handleAgreementCheckboxChange={onHandleChangeCheckBox}
                isContractingProcess
                immStep={immStep}
                precontractualMailProductInfo={precontractualMailProductInfo}
                sendMailParams={sendMailParams}
                showIneAndRevolving={true}
                showRevolvingDocument={true}
                processEmail={processEmail}
                immHireCardOpenCredit={immCardModifyLimit}
                onHandleChangeCheckBoxCC={onHandleChangeCheckBoxCC}
                ineNotCall={true}
                newIntLoading={newIntLoading}
                newCardsFF={true}
            />
        )

    }
    const legalConfirmationSection = buildLegalConfirmationSection(amount);

    const onPrintPdf = () => {
        if (getCustomTags) {
            const tag = getCustomTags({ pageName }).onPrintPdf;
            recordLinkV2(tag);
        }
    }

    const onDownloadPdf = () => {
        if (getCustomTags) {
            const tag = getCustomTags({ pageName }).onDownloadPdf;
            recordLinkV2(tag);
        }
    }

    const scrollButtonAction = () => {
        if (getCustomTags) {
            const tag = getCustomTags({ pageName }).onScrollButtonAction;
            recordLinkV2(tag);
        }
    }

    const onClickPdfLink = (documentKey, documentName) => {
        if (getCustomTags) {
            const tag = getCustomTags({ pageName, documentName }).onClickPdfLink;
            recordLinkV2(tag);
        }
    };



    return (
        <>
            {__CONTACT_CENTER__ && !isPrintOfficeMode() &&
                <BlockInfo extraClass="cancel-bizum-step1__block-info">
                    <FormattedText value={'cardModifyLimitInformativeSection-blockInfo1Step3'} injectedStrings={[keyName]} />
                </BlockInfo>
            }
            <CardModifyLimitInformativeSection
                operativeName={__CONTACT_CENTER__ && operativeName}
                immCard={immCard}
                newLimit={newLimit}
                titleKey="cardModifyLimitInformativeSection-stepTwoTitle"
                notShowScript={true}
            />
            <OKConsents placementId={placementIdCard} />
            {__CONTACT_CENTER__ && !isPrintOfficeMode() &&
                <BlockInfo extraClass="cancel-bizum-step1__block-info">
                    <p>
                        <b>
                            <FormattedText value="hirePaymentMethodComponent-hirePaymentMethodComponent_TitleCC" />
                        </b>
                    </p>
                    <p>
                        <FormattedText value="cardModifyLimitInformativeSection-blockInfo2Step3" />
                    </p>
                </BlockInfo>
            }
            {__CONTACT_CENTER__ && !isPrintOfficeMode() ?
                <ContactCenterRender>
                    {legalConfirmationSection}
                </ContactCenterRender> :
                <HireNewCreditCardPdf
                    immHireCardNameSelector={immHireCardNameSelector}
                    immHireCreditLimit={immHireCreditLimit}
                    immHirePaymentMethod={immHirePaymentMethod}
                    immShippingAddressList={immShippingAddressList}
                    hireNewCreditCard={immCardChangePaymentMethod}
                    setPrintOffice={setPrintOffice}
                    onDownloadPdf={onDownloadPdf}
                    onPrintPdf={onPrintPdf}
                    scrollButtonAction={scrollButtonAction}
                    onClickPdfLink={onClickPdfLink}
                />
            }
            {__CONTACT_CENTER__ && !isPrintOfficeMode()
                ? mailSent
                    ? buildSignatureSection()
                    : null
                : documentPolicy
                    ? buildSignatureSection()
                    : null
            }
        </>

    );
}

module.exports.constructor = ModifyNewLimitStep3;
module.exports.ModifyNewLimitStep3 = connect(
    state => ({
        immHireCreditLimit: state.hireCreditLimit,
        immHireCardNameSelector: state.hireCardNameSelector,
        immHirePaymentMethod: state.hirePaymentMethod,
        immShippingAddressList: state.shippingAddress,
        immCardChangePaymentMethod: state.cardChangeNewPaymentMethod,
        immProfile: state.profile,

    }),
    {
        requestPaymentMethodInfo: cardChangePaymentMethodActions.requestPaymentMethodInfo,
        handleAgreementCheckboxChange: cardModifyNewLimitActions.setAgreementCheckbox,
        processEmail: cardModifyNewLimitActions.processEmail,
        onHandleChangeCheckBoxCC: cardModifyNewLimitActions.onHandleChangeCheckBoxCC,

    }
)(withRouter(ModifyNewLimitStep3));




